export const URL_PARAMS = {
  transcriptId: 'call_transcript_id',
};
